import debounce from 'debounce';
import { on } from 'delegated-events';
import helpers from './helpers.js';

export default (function () {
  let htmlEl;
  let topBar;
  let nav;
  return {
    init() {
      htmlEl = document.documentElement;
      topBar = document.querySelector('.topbar');
      nav = document.querySelector('.nav-wrap');

      if (topBar === null) return;

      // Nav mobile toggle
      on('click', '.js-launch-nav', (e) => {
        e.preventDefault();
        if (!this.isOpen()) {
          this.open();
        } else {
          this.close();
        }
      });

      // Search mobile toggle
      on('click', '.js-launch-search', (e) => {
        e.preventDefault();
        this.close();
        helpers.toggleClass(htmlEl, 'is-search-open');
      });

      // add classes and toggle button to elements with flyouts
      const navItems = document.querySelectorAll('.opco-nav__item, .opco-nav__subitem');
      helpers.forEach(navItems, (i, el) => {
        if (el.querySelector('.opco-nav__flyout') !== null) {
          helpers.addClass(el, 'has-flyout');

          const link = el.querySelector('.opco-nav__link, .opco-nav__sublink');
          const href = link.getAttribute('href');
          const txt = link.textContent;

          link.setAttribute('aria-haspopup', 'true');

          const tpl = '<button class="opco-nav__back-link">Back</button>';
          el.querySelector('.opco-nav__flyout').insertAdjacentHTML('afterbegin', tpl);
        }
      });

      const closeFlyouts = () => {
        const flyouts = document.querySelectorAll('.opco-nav__item.has-flyout');
        topBar.classList.remove('has-open-flyout');
        helpers.forEach(flyouts, (i, flyout) => {
          flyout.classList.remove('is-flyout-open');
          flyout.querySelector('a').setAttribute('aria-expanded', 'false');
        });
      };

      closeFlyouts();

      const openFlyout = (flyout) => {
        if (helpers.breakpoint(nav) === 'mobile') {
          window.scroll(0, 0);
        }
        flyout.classList.add('is-flyout-open');
        flyout.querySelector('a').setAttribute('aria-expanded', 'true');
        topBar.classList.add('has-open-flyout');
      };

      const navFlyoutlinks = document.querySelectorAll('.opco-nav__item.has-flyout > .opco-nav__link');

      helpers.forEach(navFlyoutlinks, (i, el) => {
        el.addEventListener('click', (e) => {
          e.preventDefault();

          const elm = e.target;
          const navItem = elm.closest('.has-flyout');

          if (navItem.classList.contains('is-flyout-open')) {
            closeFlyouts();
          } else {
            closeFlyouts();
            openFlyout(navItem);
          }

          e.stopPropagation();
        });
      });

      const menuItems1 = document.querySelectorAll('.opco-nav__item.has-flyout');
      let timer1; let timer2;

      helpers.forEach(menuItems1, (i, el) => {
        el.addEventListener('mouseover', function (event) {
          if (helpers.breakpoint(nav) !== 'mobile') {
            closeFlyouts();
            openFlyout(this);
            clearTimeout(timer1);
          }
        });

        el.addEventListener('mouseout', (event) => {
          if (helpers.breakpoint(nav) !== 'mobile') {
            timer1 = setTimeout(() => {
              closeFlyouts();
            }, 1000);
          }
        });

        const links = el.querySelectorAll('.opco-nav__flyout a, .opco-nav__flyout button');

        helpers.forEach(links, (n, link) => {
          link.addEventListener('focus', () => {
            if (timer2) {
              clearTimeout(timer2);
              timer2 = null;
            }
          });
          link.addEventListener('blur', (event) => {
            timer2 = setTimeout(() => {
              closeFlyouts();
            }, 10);
          });
        });
      });

      // flyout mobile back
      on('click', '.opco-nav__back-link', (e) => {
        e.preventDefault();
        const el = e.target;
        const navItem = el.closest('.is-flyout-open');
        navItem.classList.remove('is-flyout-open');
        topBar.classList.remove('has-open-flyout');
        window.scroll(0, 0);
      });

      // click outside nav
      document.querySelector('.body').addEventListener('click', (e) => {
        if ((e.target.closest('.topbar') == null || e.target.closest('.location-bar') != null) && this.isOpen()) {
          this.close();
        }
      });

      const stickyNav = document.querySelector('.js-sticky-nav');
      const OpcoNav = stickyNav ? stickyNav.querySelector('.opco-nav') : null;
      const stickyLocationBar = document.querySelector('.js-sticky-location-bar');
      const innerLocationBar = stickyLocationBar ? stickyLocationBar.querySelector('.location-bar') : null;
      const page = document.querySelector('.page');
      const hasMasthead = page && (page.firstElementChild.classList.contains('masthead__bg') === true || page.firstElementChild.firstElementChild.classList.contains('masthead__bg') === true);

      const isMobile = helpers.breakpoint() === 'mobile';

      const checkNavHeights = () => {
        if (!isMobile && stickyNav !== null && !hasMasthead) {
          topBar.classList.add('has-opco-bar');
          topBar.style.marginBottom = `${stickyNav.firstElementChild.offsetHeight}px`;
        }
        if (!isMobile && stickyLocationBar !== null && !hasMasthead) {
          topBar.classList.add('has-location-bar');
          topBar.style.marginBottom = `${stickyLocationBar.firstElementChild.offsetHeight}px`;
        }
      };

      checkNavHeights();
      window.addEventListener('load', checkNavHeights);


      const animateElementIn = (scrollElement, stickyElement) => {
        if (!scrollElement || !stickyElement) {
          return;
        }
        if (scrollElement.length <= 0 || isMobile) {
          return;
        }

        if (window.scrollY > (helpers.offset(scrollElement).top + scrollElement.offsetHeight)) {
          helpers.addClass(stickyElement, 'is-sticky');
        } else {
          helpers.removeClass(stickyElement, 'is-sticky');
        }
      };

      const animateIn = () => {
        animateElementIn(stickyNav, OpcoNav);
        animateElementIn(stickyLocationBar, innerLocationBar);
      };


      window.addEventListener('scroll', debounce(() => {
        animateIn();
      }, 50, false));
    },
    close() {
      htmlEl.classList.remove('is-nav-open');

      const hasOpenFlyout = document.querySelector('.has-open-flyout');
      if (hasOpenFlyout !== null) {
        hasOpenFlyout.classList.remove('has-open-flyout');
      }

      const openFlyout = document.querySelector('.is-flyout-open');
      if (openFlyout !== null) {
        openFlyout.classList.remove('is-flyout-open');
      }

      if (htmlEl.classList.contains('is-search-open')) {
        htmlEl.classList.add('is-search-closing');
        window.setTimeout(() => {
          htmlEl.classList.remove('is-search-closing');
        }, 300);
      }
    },
    open() {
      htmlEl.classList.remove('is-search-open');
      htmlEl.classList.add('is-nav-open');
    },
    isOpen() {
      return htmlEl.classList.contains('is-nav-open');
    },
  };
}());
